import {
  Link,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import OrderActions from "./OrderActions";
import {
  FooterBox,
  StyledPaper,
  StyledTableCellHead,
  StyledTableHead,
  ellipsisSx,
} from "./style";

export default function OrderTable({
  columns = [], 
  rows = [],
  selectedTab = 0,
  tabLabels = [],
  customerDetails,
  columnsToHide = [],
  statusActionType,
  hideActions = false,
  onRowClick,
  showCustomerDetailLink = false,
  detailLinkPrefix = "/admin/customers",
}) {
  return (
    <StyledPaper tabLabel={tabLabels[selectedTab]}>
      <TableContainer sx={{ overflowX: "auto" }}>
        <Table sx={{ minWidth: 700 }}>
          <StyledTableHead tabLabel={tabLabels[selectedTab]}>
            <TableRow>
              {columns.map((col, i) => (
                <StyledTableCellHead
                  key={`${col}-${i}`}
                  sx={{ whiteSpace: "nowrap", minWidth: 100 }}
                >
                  {col}
                </StyledTableCellHead>
              ))}
            </TableRow>
          </StyledTableHead>
          <TableBody>
            {rows.length === 0 ? (
              <TableRow>
                <TableCell colSpan={columns.length} align="center">
                  <Typography>No records found</Typography>
                </TableCell>
              </TableRow>
            ) : rows.map((row, idx) => {
           const otherPayload = Object.fromEntries(
              Object.entries(row).filter(([key]) => !columnsToHide.includes(key))
            );
              return (
              <TableRow
                key={idx}
                hover={Boolean(onRowClick)}
                onClick={() => onRowClick?.(row)}
                sx={{ cursor: onRowClick ? "pointer" : "default" }}
              >
                {/* add new logic for common table */}
                {Object.keys(otherPayload).map((key) => {
                  const value = row[key];
                  if (key.toLowerCase().includes("order")) {
                    return (
                      <TableCell key={key} sx={{ whiteSpace: "nowrap" }}>
                        <Typography fontWeight={500}>
                          {value}
                        </Typography>
                      </TableCell>
                    );
                  }

                  if (showCustomerDetailLink && key === "customer" && row.id) {
                    return (
                      <TableCell key={key} sx={{ whiteSpace: "nowrap" }}>
                        <Link
                          component={RouterLink}
                          to={`${detailLinkPrefix}/${row.id}`}
                          underline="hover"
                          color="primary"
                          fontWeight={600}
                          onClick={(e) => e.stopPropagation()}
                        >
                          {value}
                        </Link>
                      </TableCell>
                    );
                  }

                  return <TableCell key={key} sx={ellipsisSx}>{value}</TableCell>;
                })}
                {!hideActions && (
                <TableCell>
                  <OrderActions
                    id={row.id}
                    status={row.isSuspended}
                    customerDetails={customerDetails}
                    statusActionType={statusActionType}
                    detailLinkPrefix={showCustomerDetailLink ? detailLinkPrefix : ""}
                  />
                </TableCell>
                )}
              </TableRow>
              // old logic for for common table
              //     <TableRow key={idx}>
              //   <TableCell>
              //     <Typography color="primary" fontWeight={500}>
              //       {row.orderId}
              //     </Typography>
              //   </TableCell>
              //   <TableCell>{row.customer}</TableCell>
              //   <TableCell>{row.email}</TableCell>
              //   <TableCell>{row.phone}</TableCell>
              //   <TableCell>{row.lockerId}</TableCell>
              //   <TableCell>{row.status}</TableCell>
              //   {/* <TableCell>
              //     <OrderStatusChip status={row.status} />
              //   </TableCell> */}
              //   <TableCell>
              //     <OrderActions id = {row.id} status = {row.isSuspended} customerDetails={customerDetails} />
              //   </TableCell>
              // </TableRow>
              
            )
            })}
          </TableBody>
        </Table>
      </TableContainer>

      <FooterBox>
        <Typography variant="body2">Showing {rows.length} results</Typography>
        {/* <StyledButtonSend
          endIcon={<MdChevronRight />}
          size="small"
          variant="outlined"
          color={
            tabLabels[selectedTab] === "Pickups" ||
            tabLabels[selectedTab] === "Shipments"
              ? "warning"
              : "primary"
          }
        >
          VIEW ALL
        </StyledButtonSend> */}
      </FooterBox>
    </StyledPaper>
  );
}
